import type { ReactNode } from 'react';
import { formatDate } from '@/shared/format';
import type { AgreementExecutionEventResponse } from '@/api/schemas/agreements.types';

/** A labelled fact in a definition list. */
export function Field(props: { label: string; value: string; mono?: boolean }): ReactNode {
  return (
    <div>
      <dt className="text-xs tracking-wide text-content-muted uppercase">{props.label}</dt>
      <dd className={props.mono ? 'font-mono text-xs break-all text-content' : 'text-content'}>
        {props.value}
      </dd>
    </div>
  );
}

/**
 * The execution's own event log.
 *
 * The events are what the server recorded, in the order it recorded them. The console does
 * not summarise or reorder them.
 */
export function ExecutionEvents(props: {
  events: ReadonlyArray<AgreementExecutionEventResponse>;
}): ReactNode {
  if (props.events.length === 0) {
    return <p className="text-sm text-content-muted">No events recorded yet.</p>;
  }
  return (
    <ol className="space-y-2 text-sm">
      {props.events.map((event) => (
        <li key={event.eventId} className="flex gap-3 border-b border-border pb-2">
          <span className="w-40 shrink-0 text-content-muted">
            {formatDate(event.occurredAt)}
          </span>
          <span className="font-medium text-content">{event.eventType}</span>
        </li>
      ))}
    </ol>
  );
}
